/* unplugin-vue-components disabled */import script from "./BlueSectionTitle.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlueSectionTitle.vue?vue&type=script&lang=ts&setup=true"

import "./BlueSectionTitle.vue?vue&type=style&index=0&id=1790118f&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1790118f"]])

export default __exports__